module.exports = __webpack_public_path__ + "img/super-app-ios.99bfc114.png";